import React, { useState, useEffect } from 'react';
import Modal from 'rsuite/Modal';
import UserForm from 'Components/Admin/User/NewUser/UserForm';
import PropTypes from 'prop-types';

export default function NewUserModal(props) {
  const {isOpen, setOpen, data, isEdit} = props;
  const [formData, setFormData] = useState(null);

  const handleClose = () => {
    if(!isEdit)
      setFormData(null);
    setOpen(false);
  }

  useEffect(() => {
    if(isEdit)
      setFormData(data);
    else setFormData(null)
  }, [data, isEdit])
  
  return (
      <Modal size="md" open={isOpen} onClose={handleClose} backdrop='static'>
        <Modal.Header>
          <Modal.Title>{formData && formData.id? 'Actualizar': 'Nuevo'} Usuario</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UserForm data={formData} close={handleClose}/>
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
  );
}

NewUserModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  data: PropTypes.object,
}